import axios from 'axios'
import { push } from 'connected-react-router'
import * as types from '../constants/actionTypes'
import { hideModal } from './modalsActions'
import { destroyCurrentConv } from './conversationActions'

export const showResolveConv = () => {
  return {
    type: types.ShowResolveConv,
  }
}

export const submitResolveConvSuccess = () => ({
  type: types.SubmitResolveConvSuccess,
})

export const submitResolveConvFailure = (error) => ({
  type: types.SubmitResolveConvFailure,
  error,
})

export const submitResolveConv = (id) => {
  return (dispatch) => {
    return axios
      .put(
        `${process.env.REACT_APP_BLINKER_API_URL}/api/v3/admin/conversations/${id}/resolve`
      )
      .then(() => {
        dispatch(submitResolveConvSuccess())
        dispatch(hideModal())
        dispatch(destroyCurrentConv())
        dispatch(push('/chat'))
      })
      .catch(() => {
        // const errorMesssage = error.response && error.response.data ? error.response.data.message : 'Something went wrong';
        // dispatch(submitResolveConvFailure(error));
      })
  }
}
